/**
 * API доступа к public.company_details (1.32.0).
 *
 * Все запросы идут через Supabase с RLS:
 *  - SELECT: admin + dispatcher своей компании
 *  - INSERT/UPDATE: только admin своей компании
 */

import { isSupabaseConfigured, requireSupabase } from '../auth/supabaseClient';
import type { CompanyDetails, CompanyDetailsInput } from './types';

/**
 * Возвращает запись company_details для указанной компании или null,
 * если записи ещё нет (модалка ещё не заполнялась).
 */
export async function fetchCompanyDetails(
  companyId: string,
): Promise<CompanyDetails | null> {
  if (!isSupabaseConfigured) return null;
  const supabase = requireSupabase();

  const { data, error } = await supabase
    .from('company_details')
    .select('*')
    .eq('company_id', companyId)
    .maybeSingle();

  if (error) {
    throw new Error(`fetchCompanyDetails: ${error.message}`);
  }
  return (data as CompanyDetails) ?? null;
}

/**
 * Создать или обновить запись company_details.
 * UPSERT по company_id (UNIQUE-constraint).
 */
export async function upsertCompanyDetails(
  companyId: string,
  input: CompanyDetailsInput,
): Promise<CompanyDetails> {
  const supabase = requireSupabase();

  const { data, error } = await supabase
    .from('company_details')
    .upsert(
      { company_id: companyId, ...input },
      { onConflict: 'company_id' },
    )
    .select('*')
    .single();

  if (error) {
    throw new Error(`upsertCompanyDetails: ${error.message}`);
  }
  return data as CompanyDetails;
}
